import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { LoginUser } from "../../models/user";
import { ChangeEvent, SyntheticEvent, useState } from "react";
import axios from "axios";
import { useStore } from "../../stores/store";
import { observer } from "mobx-react-lite";

export default observer(function Login() {

    const { userStore } = useStore();
    const [errorMessage, setError] = useState('');

    const handleLogin = async (event: SyntheticEvent) => {
        debugger
        try {
            event.preventDefault();

            const target = event.target as typeof event.target & {
                username: { value: string },
                password: { value: string }
            }

            var creds = {} as LoginUser;
            creds.username = target.username.value;
            creds.password = target.password.value;

            await userStore.login(creds);

        } catch (error: any) {
            setError(error.message);
        }

    }

    return (
        <Container>
            <Row>
                <Col lg={4}></Col>
                <Col lg={4}>
                    <h2>Login Form</h2>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col lg={4}></Col>
                <Col lg={4}>
                    <Form onSubmit={handleLogin}>
                        <Form.Group>
                            <Form.Control name='username' className='mb-4' placeholder="Enter Username" type='username' />
                            <Form.Control name='password' className='mt-2 mb-2' placeholder="Enter password" type='password' />

                        </Form.Group>
                        <Form.Group className="mt-4">
                            <Button type='submit' variant='success'>Login</Button>
                        </Form.Group>
                        <Form.Group>
                            {errorMessage &&
                                <p style={{ color: 'red' }}>{errorMessage}</p>
                            }
                        </Form.Group>
                    </Form>
                </Col>
            </Row>

        </Container>
    )
});